import React from "react";
import LotteryTypeCard from "./LotteryTypeCard";

const LotteryGroup = (props) => {
  const huayGroups = [
    // {
    //   label: "หวยแนะนำ",
    //   type: "Yeekee",
    //   icon: "",
    // },
    {
      label: "หวยที่กำลังเปิดรับแทง",
      type: "Hit",
      icon: "",
    },
    // {
    //   label: "หวยหุ้นต่างประเทศ",
    //   type: "StockMarket",
    //   icon: "",
    // },
  ];

  return (
    <div>
      {huayGroups.map((data, index) => (
        <div className="my-2" key={index}>
          <p className="text-base text-center font-bold text-[#b3853e]">{data.label}</p>
          <div className="grid grid-cols-1 gap-1 md:grid-cols-2 lg:grid-cols-3 mx-2">
            {data.type === "Hit"
              ? props.lottery
                  ?.map((data, ii) => (
                    <LotteryTypeCard
                      key={ii}
                      lotteryId={data._id}
                      roundId={data.round?._id}
                      name={data.lotteryName}
                      group={data.group}
                      closeSale={data.round?.closeSaleDatetime}
                      closeHour={
                        data.closeRoundSaleHour < 10
                          ? "0" + data.closeRoundSaleHour
                          : data.closeRoundSaleHour
                      }
                      closeMin={
                        data.closeRoundSaleMinute === 0
                          ? "00"
                          : data.closeRoundSaleMinute
                      }
                      openRoundSaleHour={
                        data.openRoundSaleHour < 10
                          ? "0" + data.openRoundSaleHour
                          : data.openRoundSaleHour
                      }
                      openRoundSaleMinute={
                        data.openRoundSaleMinute === 0
                          ? "00"
                          : data.openRoundSaleMinute
                      }
                    />
                  ))
              : props.lottery
                  // ?.filter((lottery, i) => lottery.group === data.type)
                  .map((data, ii) => (
                    <LotteryTypeCard
                      key={ii}
                      lotteryId={data._id}
                      roundId={data.round?._id}
                      name={data.lotteryName}
                      group={data.group}
                      closeSale={data.round?.closeSaleDatetime}
                      closeHour={
                        data.closeRoundSaleHour < 10
                          ? "0" + data.closeRoundSaleHour
                          : data.closeRoundSaleHour
                      }
                      closeMin={
                        data.closeRoundSaleMinute === 0
                          ? "00"
                          : data.closeRoundSaleMinute
                      }
                      openRoundSaleHour={
                        data.openRoundSaleHour < 10
                          ? "0" + data.openRoundSaleHour
                          : data.openRoundSaleHour
                      }
                      openRoundSaleMinute={
                        data.openRoundSaleMinute === 0
                          ? "00"
                          : data.openRoundSaleMinute
                      }
                    />
                  ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LotteryGroup;
